export const Draft = {
    name: 'Draft',
    value: 'DRAFT',
    sequence: 1,
};
export const Active = {
    name: 'Active',
    value: 'ACTIVE',
    sequence: 2,
};
const Basic = [Draft, Active];
const BasicByValue = Basic.reduce((hash, status) => {
    hash[status.value] = status;
    return hash;
}, {});
const BasicProps = Object.keys(BasicByValue);
export const isActive = status => status === Active.value;
export default {
    Basic,
    BasicByValue,
    BasicProps,
    Draft,
    Active,
    isActive,
};
